const config = [
  {
    providerName: 'Facebook',
    connectionName: 'facebook',
    type: 'social',
    imageSource: '/icons/providerIcons/facebook.png',
  },
  {
    providerName: 'Twitter',
    connectionName: 'twitter',
    type: 'social',
    imageSource: '/icons/providerIcons/twitter.png',
  },
  {
    providerName: 'LinkedIn',
    connectionName: 'linkedin',
    type: 'social',
    imageSource: '/icons/providerIcons/linkedin.png',
  },
  {
    providerName: 'Google',
    connectionName: 'google-oauth2',
    storageKey: 'googleoauth2',
    type: 'other',
    imageSource: '/icons/providerIcons/google.png',
  },
];

export default config;

export const findByConnectionName = (name) => config.find(
  (c) => c.connectionName.toLowerCase() === name.toLowerCase(),
);
